import { useBackend } from "../../services";

export const useGetPatreonUserId = () => {
  const { get } = useBackend();
  return async () => {
    return await get("patreon");
  };
};
